//导航自定义快捷菜单控制器
import { ReactElement, ReactNode } from "react";
import { NavMenuBubbleData } from "./bubble/types";
import { LayoutModes } from "../../../types";
import { RefComponentProps } from "../../types";
import { HeaderTeanetStore } from "../../stores/headerTenantStore";

export interface NavMenuControl {
  id?: string;  //菜单id
  visible: boolean | Function;
  render: ((params1?: any, params2?: any, params3?: any) => ReactElement);
  action?: ((params1?: any) => void);
}

//菜单类型
export enum MenuType {
  DEFAULT_MENU = "DEFAULT_MENU", //默认菜单
  CUSTOM_MENU = "CUSTOM_MENU",  //菜单
  LINE = "LINE", //分割线
}

//菜单分组类型
export enum MenuGroupType {
  NAVIGATION = "NAVIGATION", //导航栏
  MORE = "MORE" //更多
}

//菜单打开方式
export enum OpenWay {
  NEW_PAGE = 0, //新建页
  WINDOW = 1, //弹出窗口
  CURRENT_PAGE = 2 //当前页
}

//快捷菜单打开方式
export enum QuickMenuOpenWay {
  NEW_PAGE = "newPage", //新建页
  WINDOW = "newWindow", //弹出窗口
  CURRENT_PAGE = "current" //当前页
}

//弹窗窗口类型
export enum WindowSizeType {
  DEFAULT = 0,  //自适应
  CUSTOM = 1, //自定义
}

//显示方式
export enum ShowWays {
  FLOAT_MENU = "floatmenu", //更多应用浮动菜单
  TILING_PAGE = "tilingpage",   //更多应用平铺
  MAIN_MENU = "mainmenu", //工作消息主导航显示
  FLOAT_ICON = "floaticon", //工作消息浮动图标
}

//客户端类型
export enum ClientType {
  CLIENT = 'pcClient',
  WEBCLIENT = 'webClient'
}

//状态
export enum DataStatus {
  ENABLE = 1,
  DISABLE = 2
}

export class NavMenuItem {
  id?: string;
  createTime?: string;
  updateTime?: string;
  creator?: number;
  menuName: string = "";
  i18nMenuName: string = "";
  i18nCustomMenuName: string = "";
  customMenuName?: string;
  icon: string = "";
  menuEnable?: number = 0;
  url?: string;
  openWay?: OpenWay = OpenWay.NEW_PAGE;
  useLimit?: number;
  orderNo?: number;
  menuType: MenuType = MenuType.CUSTOM_MENU;
  menuAuth?: string;
  i18nId?: string = "-1";
  customI18nId: string = "-1";
  groupType?: MenuGroupType = MenuGroupType.NAVIGATION;
  windowSize?: WindowSizeType = WindowSizeType.DEFAULT;
  windowHeight?: string;
  windowWidth?: string;
  defaultOrderNo?: Number = -1; //第二排序字段 为后期追加系统默认菜单预留
  menuKey: string = ""; //作为导航菜单唯一标识
  cornerMarkSetting?: NavMenuBubbleData;
  clientType?: ClientType;
  menuNameShow?: DataStatus = DataStatus.DISABLE;
  allowUserChange?: DataStatus = DataStatus.ENABLE;
  showWay?: ShowWays = ShowWays.FLOAT_MENU;
  imCount: number = 0;
}

export enum IconShowType {
  SOLID = 0,  //实心
  LINEAR = 1  //线性
}

export interface QuickToolbarIprops extends RefComponentProps {//快捷菜单props
  source?: string;//外部引用来源
  externalMenus?: NavMenuItem[];//外部传入的菜单
  className?: string;//外部传入className
  wxPlacement?: string;//快捷菜单微信号朝向
  layoutModeCus?: LayoutModes;
  onWidthChange?: (width: number) => void;
  containerClass?: string;
  iconShowType?: IconShowType
  headerTenantStore?: HeaderTeanetStore
  customRenderBeforeQuickMenu?: () => ReactNode;
}


//类型
export enum QuickMenuType {
  APP_NEW_PAGE = "1", //应用新建页面
  SYSTEM_MENU = "2",  //系统菜单
  CUSTOM_URL = "3", //自定义URL
  LINE = "LINE", //分割线
}


export enum IconType {
  EB = "EB",
  APPICON = "APPICON"
}